module.exports = __webpack_public_path__ + "static/media/WU_STEPS_progress_symbol_active.350f3ed4.svg";